import { Bar, Line } from "react-chartjs-2"
import { chartBarOptions } from "../../helpers/chartoptions"
import { useEffect, useRef, useState } from "react"
import { getDangerColor, getDangerShortName, loadMeasurers, prepareMeasurers, ShowLocaleDateTime } from "../../helpers/helpers"
import References from "../../helpers/Reference"
import { LeftCircleOutlined, LeftSquareOutlined, RightCircleOutlined, RightSquareOutlined } from "@ant-design/icons"
import { clearForecasts, clearForecastsData, clearSourceData, getChartDatasets, getHeightForecastBar, getLastIndexInForeacasts, setLineChartOptions, showForecastLabel, showForecastTitle } from "./utils"
import { Tabs } from "antd"
import { round } from "../../helpers/helpers"

export const ForecastWaterlevel = ({mch, data, start, finish, onTabChange}) => { 

  const [activeTab, setActiveTab] = useState("summary_tab")

  const items = [
    {
      key: "summary_tab",
      label: "Сводка",
    },
    {
      key: "waterlevel_tab",
      label: "Уровень воды",

    },
    {
      key: "calc_tab",
      label: "Расчет",
    },
  ];

  const onForecastTabChange = (key) => {
    setActiveTab(key)
    onTabChange?.(key);
  }

  return (
    <>
      <div className="ph-2" >
      <Tabs
        defaultActiveKey="summary_tab"
        items={items}
        onChange={onForecastTabChange}
      />
      </div>

      {activeTab === "summary_tab" && 
        <ForecastWaterLevelSummary 
          mch={mch}
        />
      }

      {activeTab === "waterlevel_tab" && 
          <ChartForecastWaterlevel 
            uuid={mch.mchs.waterlevel}
            mch={mch}            
            start={start}
            finish={finish}
          />
      }

      {activeTab === "calc_tab" && 
        <ForecastWaterlevelCalculate 
        data={data}
      />
      }

    </>
  );

}

const ForecastWaterLevelSummary = ({mch}) => {
  return (
    <div className="ph-2 text-small">
      <div className="col-3 borderb-eee pb-1">
          <div>Уровень воды:</div>
          <div>{ShowLocaleDateTime(mch.mchs.state?.last_value?.waterlevel?.time)}</div>
          <div>{round(mch.mchs.state?.last_value?.waterlevel?.bs, References.mchs.waterlevel.precision)} {References.mchs.waterlevel.unit}</div>          
      </div>

      <div className="mt-2 b text-md">
        Расчет на {ShowLocaleDateTime(mch.mchs.state?.last_value?.forecastwaterlevel?.time)}
      </div>

      <div className="col-3 mt-2">
          <div>Достижения уровня НЯ:</div>
          <div>{mch.mchs.state?.last_value?.forecastwaterlevel?.time_prevention ? ShowLocaleDateTime(mch.mchs.state.last_value.forecastwaterlevel.time_prevention) : '---'}</div>
          <div>{showForecastTitle(mch.mchs.state?.last_value?.forecastwaterlevel?.case_prevention)}</div>
      </div>

      <div className="col-3 mt-1">
          <div>Достижение уровня ОЯ:</div>
          <div>{mch.mchs.state?.last_value?.forecastwaterlevel?.time_danger ? ShowLocaleDateTime(mch.mchs.state.last_value.forecastwaterlevel.time_danger) : '---'}</div>
          <div>{showForecastTitle(mch.mchs.state?.last_value?.forecastwaterlevel?.case_danger)}</div>
      </div>

      <div className="col-3 mt-1">
          <div>Максимальный уровень: </div>
          <div>{mch.mchs.state?.last_value?.forecastwaterlevel?.time_max_bs ? ShowLocaleDateTime(mch.mchs.state.last_value.forecastwaterlevel.time_max_bs) : '---'}</div>
          <div>{mch.mchs.state?.last_value?.forecastwaterlevel?.max_bs ? 
              `${mch.mchs.state?.last_value?.forecastwaterlevel?.max_bs}, ${References.mchs.forecastwaterlevel.unit}` : 
              '---'
              }
            </div>
      </div>
    </div>
  )
}

const ForecastWaterlevelCalculate = ({data}) => {  

  const [forecasts, setForecasts ] = useState([])
  const [message, setMessage] = useState(data.source[0])
  const [index, setIndex] = useState(0);
  const [amount, setAmount] = useState(0)

  useEffect(
    () => {
      const clearForecasts = clearForecastsData([...data.source].reverse())
      const lastIndex = clearForecasts.length - 1;
      setForecasts(clearForecasts)
      setAmount(lastIndex)
      setMessage(clearForecasts[0])      
    },
    [data]
  )  

  const setPrevIndex = () => {
    const newIndex = index + 1;
    if (newIndex > amount) return;
    setIndex(newIndex);
    setMessage(forecasts[newIndex]);
  }
  
  const setNextIndex = () => {
    const newIndex = index - 1;
    if (newIndex < 0) return;
    setIndex(newIndex);
    setMessage(forecasts[newIndex]);
  }

  const onClickRow = (idx) => {
    setIndex(idx)
    setMessage(forecasts[idx])
  }


  return (
    <>
    <div style={{height: "50%", overflowY: "auto"}}>
      <div style={{padding: "10px 25px"}} className="text-small">
        <div className="d-flex v-align-center">
          <div className="level_code_lamp">
            <div level_code_text={Number.isFinite(message?.danger_level) ? message?.danger_level : -2}>&#9679;</div>
          </div>
          <div className="text-md b ml-2">{ShowLocaleDateTime(message?.time)}</div>
          <div className="ml-4">
            <LeftCircleOutlined onClick={setPrevIndex} className="text-llg"/>
            <RightCircleOutlined onClick={setNextIndex} className="ml-1 text-llg"/>

          </div>
        </div>
        <div className="mt-2">
          <div className="col-3">
            <div>Превышение уровня НЯ:</div>
            <div>{message?.time_prevention ? ShowLocaleDateTime(message.time_prevention) : '---'}</div>
            <div>{showForecastTitle(message?.case_prevention)}</div>
          </div>
          <div className="col-3 mt-1">
            <div>Превышение уровня ОЯ:</div>
            <div>{message?.time_danger ? ShowLocaleDateTime(message.time_danger) : '---'}</div>
            <div>{showForecastTitle(message?.case_danger)}</div>
          </div>
          <div className="col-3 mt-1">
            <div>Максимальный уровень:</div>
            <div>{message?.time_max_bs ? ShowLocaleDateTime(message.time_max_bs) : '---'}</div>
            <div>{message?.max_bs ?
              `${message?.max_bs}, ${References.mchs.forecastwaterlevel.unit}` : 
              '---'
              }
            </div>
          </div>

        </div>
        {message?.message &&
          <div className="mt-1 rem border-555 p-1">
            {message.message}
          </div>
        }
      </div>

    </div>

    <div 
      style={{
        overflowY: "hidden",
        height: "50%",
      }}
    >
      <div
        style={{
          height: "100%",
          overflowY: "auto",
          padding: "0 25px"
        }}
      >
        <div className="table-small table-small-header">
          <div style={{width: "28%"}}>Время</div>
          <div style={{width: "16%"}} className="overflow-ellipse">Состояние</div>
          <div style={{width: "28%"}}>НЯ</div>
          <div style={{width: "28%"}}>ОЯ</div>
        </div>
        {forecasts.map((item, idx) => {return (
        <div 
          className={`table-small 
          ${idx === index ? 'border-555' : null}`} 
          onClick={() => onClickRow(idx)}
          key={`forecast-message-row-${idx}`}
        >
            <div style={{width: "28%"}}>{ShowLocaleDateTime(item.time)}</div>
            <div style={{width: "16%", backgroundColor: getDangerColor(item.danger_level)}}>{getDangerShortName(item.danger_level)}</div>
            <div style={{width: "28%"}}>{showForecastLabel(item.time_prevention, item.case_prevention)}</div>
            <div style={{width: "28%"}}>{showForecastLabel(item.time_danger, item.case_danger)}</div>
        </div>
        )
        })}
      </div>
    </div>
</>

  )
}

const ChartForecastWaterlevel = ({mch, uuid, start, finish}) => {

  const BASIS = 'waterlevel.bsv'

  const [chartData, setChartData] = useState([])
  const [isLoaded, setIsLoaded]= useState(false)

  useEffect(() => {
    loadMeasurers(uuid, 'mchs', 'waterlevel', start, finish)
    .then(data => {
      setChartData(prepareMeasurers(data, uuid, 'mchs', 'waterlevel') );      
      setIsLoaded(true)
    })
  }, [uuid, start, finish])  

  return (        
    <div style={{minHeight: 0, flex: "1 1 0"}}>     
      {isLoaded &&                        
      <Line
        key={uuid}
        data={{
            labels: chartData.labels,
            datasets: getChartDatasets( chartData, mch, null )
        }}
        options={setLineChartOptions(mch, chartData, BASIS)}
        redraw={false}
      />
      }
    </div>    
  )
}

const FenceForecastWaterlevel = ({data, isFence}) => {

  const forecastRef = useRef(null)

  const [message, setMessage] = useState(data.source[0])
  const [index, setIndex] = useState(0);
  const [amount, setAmount] = useState(0)

  useEffect(
    () => {
      if (forecastRef.current) {
        forecastRef.current.scrollLeft = forecastRef.current.scrollWidth;
      }     
      const lastIndex = getLastIndexInForeacasts(data.data);
      setAmount(lastIndex)
      setIndex(lastIndex)
      setMessage(data.source[lastIndex])
    },
    [data]
  )

  const setPrevIndex = () => {
    const newIndex = index - 1;
    if (newIndex < 0) return;
    setIndex(newIndex);
    setMessage(data.source[newIndex]);
  }
  
  const setNextIndex = () => {
    const newIndex = index + 1;
    if (newIndex > amount) return;
    setIndex(newIndex);
    setMessage(data.source[newIndex]);
  }

  const chartData = {
    labels: data.labels,
    datasets: [
      {
        data: data.data.map((item, idx) => {   
          return getHeightForecastBar(item, idx === index)
        }), 
        backgroundColor: data.data.map((item) =>
          getDangerColor(item)
        ),
        borderColor: data.data.map((_, i) =>
          i === index
            ? "#999" // цвет выделения
            : "transparent"
        ),
  
        borderWidth: data.data.map((_, i) =>
          i === index
            ? 1
            : 0
        ),        
        barThickness: 5, // фиксированная ширина колонки
        borderRadius: 2,
      },
    ],
  };


  const options = {
    responsive: true,
    onClick: (_, elements) => {
      if (!elements.length) return;
  
      const index = elements[0].index;
      setMessage(data.source[index]);
      setIndex(index)
  
    },    
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,

        callbacks: {
          label: (item) => {
            const level = data.data[item.dataIndex];
            return getDangerShortName(level);
          }
        },        
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        display: false, // скрываем ось Y
        min: 0,
        max: 1,
      },
    },
  };
      
    return (
      <>
      <div style={{height: "50%"}}>
        <div style={{padding: "10px 25px"}}>
          <div className="d-flex">
            <div className="level_code_lamp">
              <div level_code_text={Number.isFinite(message?.danger_level) ? message?.danger_level : -2}>&#9679;</div>
            </div>
            <div className="text-llg">{ShowLocaleDateTime(message?.time)}</div>
            <div className="ml-4">
              <LeftSquareOutlined onClick={setPrevIndex} className="text-llg"/>
              <RightSquareOutlined onClick={setNextIndex} className="ml-1 text-llg"/>

            </div>
          </div>
          <div>
            {isFence ? 
              message?.message?.map((val, idx) => {
              return (
                <div key={`message-${idx}`} className="pt-2">
                  {val}
                </div>
              )
            })
            :
            <>{message?.message}</>
          }
          </div>
        </div>

      </div>

      <div 
        ref={forecastRef}      
        style={{
          overflowX: "auto",
          height: "50%",
          marginLeft: 20,
          marginRight: 20

        }}
      >
        <div
          style={{
            width: isFence ? data.labels.length * 7 : "auto",
            height: "100%"
          }}
        >
          {isFence ?          
          <Bar data={chartData} options={options} />
          :
          <ForecastWaterlevel /> 
          }
        </div>
      </div>
</>
    )
}